import { Component, computed, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IMAGES } from 'shared/constants/imagePaths.constants';
import { PermissionDirective } from 'shared/directives/permission.directive';
import { HelpPageLocations, helpPageLocationsEnumMap, helpPageLocationsUrlMap } from 'shared/enums/shared-url-locations.enum';
import { isCurrentSupplierUser } from 'shared/interfaces/current-supplier-user.interface';
import { UserApiService } from 'shared/services';
import { SidebarService } from 'shared/services/sidebar.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    imports: [TranslateModule, RouterLink, RouterLinkActive, PermissionDirective],
})
export class SidebarComponent implements OnInit {
    protected readonly isExpanded = this.sidebarService.isExpanded;
    protected readonly isCollapsed = computed(() => !this.isExpanded());

    protected isShiji!: boolean;
    protected hasAccessToIce: boolean = false;
    protected hasAccessToDal: boolean = false;
    protected IMAGES = IMAGES;

    constructor(
        private userApiService: UserApiService,
        private sidebarService: SidebarService,
        private destroyRef: DestroyRef,
        private router: Router,
    ) {}

    public ngOnInit(): void {
        this.userApiService.getLoginInformationContinuously().subscribe((loginInfo) => {
            this.isShiji = loginInfo.isShiji;
            if (isCurrentSupplierUser(loginInfo)) {
                this.hasAccessToIce = loginInfo.hasAccessToIce;
                this.hasAccessToDal = loginInfo.hasAccessToDAL;
            }
        });
    }

    public toggleExpanded(): void {
        this.sidebarService.toggleExpanded();
    }

    public openHelpTab(pageUrl?: string): void {
        this.sidebarService
            .getHelpPageToken()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((token) => {
                const prodEnvPortal = 'https://docs.shijigroup.com';
                const portalUrl = `${prodEnvPortal}/auth/login`;
                const params = new URLSearchParams();
                params.set('jwt', token);

                if (pageUrl) {
                    // Remove the base URL from pageUrl if it exists
                    pageUrl = pageUrl.replace(prodEnvPortal, '');
                    params.set('redirect', pageUrl);
                } else {
                    // Default redirect page
                    params.set('redirect', this.getHelpPageLinkByLocation());
                }

                // Construct the full URL with query parameters
                const helpLink = `${portalUrl}?${params.toString()}`;

                // Open the constructed help link in a new tab
                window.open(helpLink, '_blank');
            });
    }

    private getHelpPageLinkByLocation(): string {
        const url = this.router.url;
        switch (true) {
            case url.includes(helpPageLocationsUrlMap[HelpPageLocations.DASHBOARD]):
                return helpPageLocationsEnumMap[HelpPageLocations.DASHBOARD];
            case url.includes(helpPageLocationsUrlMap[HelpPageLocations.LISTING_PAGE]):
                return helpPageLocationsEnumMap[HelpPageLocations.LISTING_PAGE];
            case url.includes(helpPageLocationsUrlMap[HelpPageLocations.LISTINGS]):
                return helpPageLocationsEnumMap[HelpPageLocations.LISTINGS];
            case url.includes(helpPageLocationsUrlMap[HelpPageLocations.USERS]):
                return helpPageLocationsEnumMap[HelpPageLocations.USERS];
            default:
                return helpPageLocationsEnumMap[HelpPageLocations.DEFAULT];
        }
    }
}
